export const csrfKeys = {
  getAll: ['csrf-token']
};
